import { render } from "./HeadComponent.vue?vue&type=template&id=653d452f&scoped=true"
import script from "./HeadComponent.vue?vue&type=script&lang=js"
export * from "./HeadComponent.vue?vue&type=script&lang=js"

import "./HeadComponent.vue?vue&type=style&index=0&id=653d452f&scoped=true&lang=css"

import exportComponent from "D:\\yuqiang\\笔记\\git-document\\document\\workspace\\modingtech\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653d452f"]])

export default __exports__